import type { CityData } from "./cities-data.types";

export const CITY_CATALOG_A: CityData[] = [
  {
    slug: "new-delhi",
    name: "New Delhi",
    name_hi: "नई दिल्ली",
    state: "Delhi",
    latitude: 28.6139,
    longitude: 77.209,
    timezone: "Asia/Kolkata",
    regional_note:
      "The Akshardham Temple, Birla Mandir, and Lotus Temple are key spiritual landmarks. Delhiites observe Chhath Puja, Lohri, and Diwali with particular devotion. Being the seat of government, auspicious muhurtas for government dealings and official work are especially significant here.",
    local_festivals: ["Chhath Puja", "Lohri", "Diwali"],
  },
  {
    slug: "mumbai",
    name: "Mumbai",
    name_hi: "मुंबई",
    state: "Maharashtra",
    latitude: 19.076,
    longitude: 72.8777,
    timezone: "Asia/Kolkata",
    regional_note:
      "Mumbai, Maharashtra's financial capital, follows IST. The Siddhivinayak Temple (Ganesh), Mahalaxmi Temple, and Walkeshwar Temple are the city's major spiritual centers. Mumbai celebrates Ganesh Chaturthi with unmatched fervor — the 10-day festival shapes the city's spiritual calendar. Auspicious timings for business ventures and financial dealings are particularly sought here.",
    local_festivals: ["Ganesh Chaturthi", "Gudi Padwa", "Navratri"],
  },
  {
    slug: "bangalore",
    name: "Bangalore",
    name_hi: "बेंगलुरु",
    state: "Karnataka",
    latitude: 12.9716,
    longitude: 77.5946,
    timezone: "Asia/Kolkata",
    regional_note:
      // 2026-07-29: removed two unsourced claims. The sunrise range stated here was
      // 6:00–6:45 AM; the engine computes 5:57–6:49 (rule 29 owns that fact now, and
      // no prose may restate it). It also named the Chamundeshwari Temple as a
      // Bangalore sacred site — it stands on Chamundi Hills at Mysuru, ~140 km away.
      "Bengaluru (Bangalore), India's Silicon Valley, sits close to the equator. Ugadi (Kannada New Year), Dasara, and Makara Sankranti are the major festivals. Tech professionals frequently consult choghadiya for product launches, funding meetings, and joining dates.",
    local_festivals: ["Ugadi", "Dasara", "Makara Sankranti"],
  },
  {
    slug: "hyderabad",
    name: "Hyderabad",
    name_hi: "हैदराबाद",
    state: "Telangana",
    latitude: 17.385,
    longitude: 78.4867,
    timezone: "Asia/Kolkata",
    regional_note:
      "Hyderabad, the City of Pearls. Birla Mandir, Chilkur Balaji Temple (Visa Balaji), and Keesaragutta Temple are major pilgrimage sites. Bonalu (Goddess worship), Bathukamma (floral festival), and Ugadi mark the Hyderabad calendar. Choghadiya is routinely consulted for business launches in Hyderabad's growing IT and pharmaceutical sectors.",
    local_festivals: ["Bonalu", "Bathukamma", "Ugadi"],
  },
  {
    slug: "chennai",
    name: "Chennai",
    name_hi: "चेन्नई",
    state: "Tamil Nadu",
    latitude: 13.0827,
    longitude: 80.2707,
    timezone: "Asia/Kolkata",
    regional_note:
      "Chennai, Tamil Nadu's capital. Kapaleeshwarar Temple, Parthasarathy Temple, and Ashtalakshmi Temple are the city's sacred anchors. Pongal (Tamil harvest festival), Tamil New Year (Puthandu), and Karthigai Deepam are major festivals. Tamils have a rich Panchanga tradition — the Tamil Panchangam is consulted alongside Hindi almanacs for auspicious timings.",
    local_festivals: ["Pongal", "Tamil New Year", "Karthigai Deepam"],
  },
  {
    slug: "kolkata",
    name: "Kolkata",
    name_hi: "कोलकाता",
    state: "West Bengal",
    latitude: 22.5726,
    longitude: 88.3639,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kolkata, the cultural capital of India. Dakshineswar Kali Temple, Kalighat Temple, and Belur Math are the city's premier pilgrimage sites. Durga Puja (Navratri) is Kolkata's grandest festival, celebrated with unparalleled artistry. Kali Puja (Diwali night) is observed with special reverence.",
    local_festivals: ["Durga Puja", "Kali Puja", "Rath Yatra"],
  },
  {
    slug: "pune",
    name: "Pune",
    name_hi: "पुणे",
    state: "Maharashtra",
    latitude: 18.5204,
    longitude: 73.8567,
    timezone: "Asia/Kolkata",
    regional_note:
      "Pune, Maharashtra's cultural and educational hub, follows IST. The Dagdusheth Halwai Ganpati Temple and Parvati Hill Temple are Pune's beloved spiritual landmarks. Ganesh Chaturthi in Pune carries special historical significance as Bal Gangadhar Tilak transformed it into a community festival here in 1893. Choghadiya is widely used for business, property, and educational decisions.",
    local_festivals: ["Ganesh Chaturthi", "Gudi Padwa", "Diwali"],
  },
  {
    slug: "ahmedabad",
    name: "Ahmedabad",
    name_hi: "अहमदाबाद",
    state: "Gujarat",
    latitude: 23.0225,
    longitude: 72.5714,
    timezone: "Asia/Kolkata",
    regional_note:
      "Ahmedabad, Gujarat's largest city. BAPS Swaminarayan Akshardham and the Hutheesing Jain Temple are the city's most revered sacred sites. Navratri in Ahmedabad is celebrated with incomparable Garba — it's a UNESCO-recognized cultural event. Uttarayan (Makar Sankranti kite festival) is Ahmedabad's defining celebration. Gujarati businesspeople have a centuries-old tradition of consulting muhurta for all major commercial decisions.",
    local_festivals: ["Navratri", "Uttarayan", "Diwali"],
  },
  {
    slug: "jaipur",
    name: "Jaipur",
    name_hi: "जयपुर",
    state: "Rajasthan",
    latitude: 26.9124,
    longitude: 75.7873,
    timezone: "Asia/Kolkata",
    regional_note:
      "Jaipur, the Pink City. The Govind Dev Ji Temple, Birla Mandir, and Galtaji (Monkey Temple) are major pilgrimage sites. Teej (monsoon festival), Gangaur, and Makar Sankranti are Rajasthan's beloved festivals. Jaipur's artisan and trader community has deep roots in Vedic timing practices — muhurta consultation before jewelry, gemstone, and property transactions is especially common.",
    local_festivals: ["Teej", "Gangaur", "Makar Sankranti"],
  },
  {
    slug: "lucknow",
    name: "Lucknow",
    name_hi: "लखनऊ",
    state: "Uttar Pradesh",
    latitude: 26.8467,
    longitude: 80.9462,
    timezone: "Asia/Kolkata",
    regional_note:
      "Lucknow, the City of Nawabs. Mankameshwar Temple, Aliganj Hanuman Temple, and Chota Imambara are major spiritual sites. Ram Navami, Dussehra, and Chhath Puja are observed with great devotion in this UP capital. As a traditional city with deep Sanskrit scholarly roots, Lucknow has strong traditions of Panchanga consultation and Vedic astrology.",
    local_festivals: ["Ram Navami", "Dussehra", "Chhath Puja"],
  },
  {
    slug: "surat",
    name: "Surat",
    name_hi: "सूरत",
    state: "Gujarat",
    latitude: 21.1702,
    longitude: 72.8311,
    timezone: "Asia/Kolkata",
    regional_note:
      "Surat, the diamond and textile capital of India, follows IST. Swaminarayan Temple and Sarthana Jain Tirth are the city's major sacred centers. Uttarayan is celebrated with particular enthusiasm in the diamond city. Surat's dominant Jain community has a well-established tradition of seeking auspicious muhurtas for diamond trading, business openings, and major financial transactions.",
    local_festivals: ["Uttarayan", "Navratri", "Diwali"],
  },
  {
    slug: "kanpur",
    name: "Kanpur",
    name_hi: "कानपुर",
    state: "Uttar Pradesh",
    latitude: 26.4499,
    longitude: 80.3319,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kanpur, Uttar Pradesh's industrial hub. Shri Radhakrishna Temple (JK Temple) and Panki Dham (Hanuman Temple) are the city's beloved pilgrimage sites. Ram Navami, Dussehra, and Chhath Puja are observed with great community participation. Kanpur's industrial and leather trade communities have long traditions of muhurta consultation for factory openings and major commercial ventures.",
    local_festivals: ["Ram Navami", "Chhath Puja", "Dussehra"],
  },
  {
    slug: "nagpur",
    name: "Nagpur",
    name_hi: "नागपुर",
    state: "Maharashtra",
    latitude: 21.1458,
    longitude: 79.0882,
    timezone: "Asia/Kolkata",
    regional_note:
      "Nagpur, the Orange City and geographic center of India. Tekdi Ganesh Mandir, Shri Ram Mandir (Civil Lines), and Ambazari Ganesh are major sacred sites. Ganesh Chaturthi, Nagpancha (Nag Panchami), and Dussehra are celebrated fervently. As Maharashtra's second-largest city with deep Marathi cultural roots, Nagpur has strong muhurta traditions.",
    local_festivals: ["Ganesh Chaturthi", "Nagpancha", "Dussehra"],
  },
  {
    slug: "indore",
    name: "Indore",
    name_hi: "इंदौर",
    state: "Madhya Pradesh",
    latitude: 22.7196,
    longitude: 75.8577,
    timezone: "Asia/Kolkata",
    regional_note:
      "Indore, Madhya Pradesh's commercial capital. The Khajrana Ganesh Mandir is considered one of the most powerful Ganesh temples in central India, drawing devotees from across the region. Navratri and Ganesh Chaturthi are Indore's major celebrations. Indore's Marwari and Gujarati merchant communities maintain deep traditions of muhurta observation for business, property, and marriage decisions.",
    local_festivals: ["Navratri", "Ganesh Chaturthi", "Diwali"],
  },
  {
    slug: "thane",
    name: "Thane",
    name_hi: "ठाणे",
    state: "Maharashtra",
    latitude: 19.2183,
    longitude: 72.9781,
    timezone: "Asia/Kolkata",
    regional_note:
      "Thane, Maharashtra's lake city adjacent to Mumbai. Kopineshwar Temple (dedicated to Lord Shiva), Talao Pali Lake shrines, and Shri Ganesh temple are major sacred sites. Thane's growing IT and real estate sectors actively use choghadiya for auspicious timing of property registrations and business launches. Ganesh Chaturthi and Gudi Padwa are the most celebrated festivals.",
    local_festivals: ["Ganesh Chaturthi", "Gudi Padwa", "Navratri"],
  },
  {
    slug: "bhopal",
    name: "Bhopal",
    name_hi: "भोपाल",
    state: "Madhya Pradesh",
    latitude: 23.2599,
    longitude: 77.4126,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bhopal, the City of Lakes and Madhya Pradesh's capital. Birla Mandir (Lakshmi Narayan) and the ancient Bhojpur Shiva Temple (Great Shiva Temple, 11th century) are major pilgrimage destinations. Navratri, Teej, and Diwali are celebrated with great fervor. Bhopal's residents and government circles have maintained traditional Panchanga consultation practices across generations.",
    local_festivals: ["Navratri", "Teej", "Diwali"],
  },
  {
    slug: "visakhapatnam",
    name: "Visakhapatnam",
    name_hi: "विशाखापट्टनम",
    state: "Andhra Pradesh",
    latitude: 17.6868,
    longitude: 83.2185,
    timezone: "Asia/Kolkata",
    regional_note:
      "Visakhapatnam (Vizag), Andhra Pradesh's port city. Simhachalam Narasimha Temple, Kali Mata Temple (Dargamitta), and Srikakula Andhra Mahavishnu Temple are major pilgrimage sites. Ugadi (Telugu New Year), Sankranti, and Vijayadashami are major festivals. Vizag's fishing, shipping, and steel communities use muhurtas for major operations and launches.",
    local_festivals: ["Ugadi", "Sankranti", "Vijayadashami"],
  },
  {
    slug: "patna",
    name: "Patna",
    name_hi: "पटना",
    state: "Bihar",
    latitude: 25.5941,
    longitude: 85.1376,
    timezone: "Asia/Kolkata",
    regional_note:
      "Patna, the historic capital of Bihar. Patna Sahib Gurudwara, Mahavir Mandir, and Patna Devi Temple are the city's revered pilgrimage centers. Chhath Puja is Bihar's most sacred festival — its solar worship is deeply connected to sunrise and sunset timings. The Panchanga is integral to Bihari cultural life.",
    local_festivals: ["Chhath Puja", "Ram Navami", "Makar Sankranti"],
  },
  {
    slug: "vadodara",
    name: "Vadodara",
    name_hi: "वड़ोदरा",
    state: "Gujarat",
    latitude: 22.3072,
    longitude: 73.1812,
    timezone: "Asia/Kolkata",
    regional_note:
      "Vadodara (Baroda), Gujarat's cultural capital. EME Temple (military temple), Kirti Mandir, and the ancient Vadodara Sun Temple are major sacred sites. Navratri in Vadodara is celebrated with royal splendor, tracing back to the Gaekwad dynasty's patronage of the festival. The city's traditional Gujarati merchant and Brahmin communities maintain detailed Panchanga traditions.",
    local_festivals: ["Navratri", "Uttarayan", "Diwali"],
  },
  {
    slug: "ghaziabad",
    name: "Ghaziabad",
    name_hi: "गाज़ियाबाद",
    state: "Uttar Pradesh",
    latitude: 28.6692,
    longitude: 77.4538,
    timezone: "Asia/Kolkata",
    regional_note:
      "Ghaziabad, the Gateway of Uttar Pradesh bordering Delhi. Dudheshwar Nath Temple and Shri Dulheshwar Nath Mandir are major temples. Diwali, Ram Navami, and Chhath Puja are observed with strong community participation. As a major NCR industrial and residential hub, Ghaziabad residents regularly consult choghadiya for property registrations, new business openings, and joining dates.",
    local_festivals: ["Diwali", "Ram Navami", "Chhath Puja"],
  },
  {
    slug: "ludhiana",
    name: "Ludhiana",
    name_hi: "लुधियाना",
    state: "Punjab",
    latitude: 30.901,
    longitude: 75.8573,
    timezone: "Asia/Kolkata",
    regional_note:
      // 2026-07-29: removed "Durgiana Temple and Ram Tirath Ashram are major
      // pilgrimage sites." Both are in AMRITSAR, ~140 km away — Wikipedia places
      // Durgiana "near the Hathi gate in Amritsar" and Ram Tirath "11 Km West of
      // Amritsar", and the Amritsar district portal lists both. Same class as the
      // Chamundeshwari-at-Bangalore claim: a true fact attached to the wrong
      // subject. Recorded as a disagreement in existence_claim_sources.yaml and
      // left UNWRITTEN (ADR-0073 L5); do not re-add it here.
      "Ludhiana, Punjab's industrial capital. Lohri (Punjab's harvest festival), Baisakhi, and Gurpurab (Sikh holy days) define Ludhiana's festive calendar. Muhurta is widely consulted for marriage, property, and business decisions in this prosperous Punjabi city.",
    local_festivals: ["Lohri", "Baisakhi", "Gurpurab"],
  },
  {
    slug: "agra",
    name: "Agra",
    name_hi: "आगरा",
    state: "Uttar Pradesh",
    latitude: 27.1767,
    longitude: 78.0081,
    timezone: "Asia/Kolkata",
    regional_note:
      "Agra, home to the Taj Mahal. Mankameshwar Temple and Rawatpara Temple are key spiritual sites. Diwali and Ram Navami are Agra's major festivals. Beyond its world-famous monuments, Agra has a vibrant traditional community that maintains Vedic timing practices for marriages, new ventures, and festivals — consulting the Panchanga before any significant event is common practice.",
    local_festivals: ["Diwali", "Ram Navami", "Holi"],
  },
  {
    slug: "nashik",
    name: "Nashik",
    name_hi: "नासिक",
    state: "Maharashtra",
    latitude: 19.9975,
    longitude: 73.7898,
    timezone: "Asia/Kolkata",
    regional_note:
      "Nashik, one of India's most sacred cities, hosts the Kumbh Mela every 12 years on the banks of the Godavari River. Trimbakeshwar Jyotirlinga, Saptashringi Temple, and Kalaram Temple are among Maharashtra's holiest shrines. Navaratri and Kumbh Mela are Nashik's defining spiritual events. With its status as a pilgrimage city, Panchanga and muhurta consultation are deeply embedded in Nashik's cultural DNA.",
    local_festivals: ["Kumbh Mela", "Navratri", "Ram Navami"],
  },
  {
    slug: "faridabad",
    name: "Faridabad",
    name_hi: "फरीदाबाद",
    state: "Haryana",
    latitude: 28.4089,
    longitude: 77.3178,
    timezone: "Asia/Kolkata",
    regional_note:
      "Faridabad, Haryana's industrial city bordering Delhi. Sheetla Mata Temple is a major pilgrimage site, especially during Navratri. Dussehra, Teej, and Baisakhi are the major festivals. Faridabad's large migrant worker community from UP, Bihar, and Rajasthan brings diverse Panchanga traditions to the city. Choghadiya is regularly consulted for factory, business, and property decisions.",
    local_festivals: ["Navratri", "Dussehra", "Baisakhi"],
  },
  {
    slug: "meerut",
    name: "Meerut",
    name_hi: "मेरठ",
    state: "Uttar Pradesh",
    latitude: 28.9845,
    longitude: 77.7064,
    timezone: "Asia/Kolkata",
    regional_note:
      "Meerut, a historic city in western Uttar Pradesh. Augarnath Temple (known as Kali Paltan Mandir) and Shiv Dham Mandir are major sacred sites. Ram Navami and Dussehra are celebrated with processions. Meerut is historically significant as the starting point of the 1857 revolt and has a strong cultural identity. The city's traditional communities actively use Panchanga for marriages and business.",
    local_festivals: ["Ram Navami", "Dussehra", "Diwali"],
  },
  {
    slug: "varanasi",
    name: "Varanasi",
    name_hi: "वाराणसी",
    state: "Uttar Pradesh",
    latitude: 25.3176,
    longitude: 82.9739,
    timezone: "Asia/Kolkata",
    regional_note:
      "Varanasi (Kashi), the eternal city on the Ganges, is the spiritual capital of India. Kashi Vishwanath Jyotirlinga, Sankat Mochan Hanuman Temple, and 84 Ghats are the city's sacred fabric. Dev Deepawali, Mahashivaratri, and Ganga Dussehra are unique to Varanasi. Vedic almanac knowledge is part of daily life here.",
    local_festivals: ["Dev Deepawali", "Mahashivaratri", "Ganga Dussehra"],
  },
  {
    slug: "srinagar",
    name: "Srinagar",
    name_hi: "श्रीनगर",
    state: "Jammu & Kashmir",
    latitude: 34.0837,
    longitude: 74.7973,
    timezone: "Asia/Kolkata",
    regional_note:
      "Srinagar, the summer capital of Jammu & Kashmir. Shankaracharya Temple (Jyeshtharudra Mandir) and Kheer Bhawani Temple are major Hindu pilgrimage sites. Shivratri (Kashmiri Herath festival) is celebrated with unique Kashmiri Hindu traditions. The dramatic seasonal variation in sunrise makes Panchanga tools especially useful here.",
    local_festivals: ["Herath (Kashmiri Shivaratri)", "Navreh (Kashmiri New Year)", "Baisakhi"],
  },
  {
    slug: "amritsar",
    name: "Amritsar",
    name_hi: "अमृतसर",
    state: "Punjab",
    latitude: 31.634,
    longitude: 74.8723,
    timezone: "Asia/Kolkata",
    regional_note:
      "Amritsar, the holiest city of the Sikh faith. The Golden Temple (Harmandir Sahib) is one of India's most visited spiritual sites, with sunrise Kirtan Darbar being a daily sacred event. Baisakhi (Sikh New Year) and Gurpurab (birthday of Guru Nanak Dev Ji) are the city's most sacred festivals. Amritsar's Hindu community also actively observes Navratri and Diwali using traditional Panchanga guidance.",
    local_festivals: ["Baisakhi", "Gurpurab", "Diwali"],
  },
  {
    slug: "ranchi",
    name: "Ranchi",
    name_hi: "रांची",
    state: "Jharkhand",
    latitude: 23.3441,
    longitude: 85.3096,
    timezone: "Asia/Kolkata",
    regional_note:
      "Ranchi, Jharkhand's capital on the Chota Nagpur Plateau. Jagannath Temple (replica of Puri), Pahari Mandir (Shiva temple on hilltop), and Deori Temple are the major sacred sites. Sarhul (spring tribal festival) and Karma (harvest festival) are unique to Jharkhand, blending tribal and Hindu traditions. Chhath Puja is observed widely.",
    local_festivals: ["Sarhul", "Karma", "Chhath Puja"],
  },
  {
    slug: "coimbatore",
    name: "Coimbatore",
    name_hi: "कोयम्बटूर",
    state: "Tamil Nadu",
    latitude: 11.0168,
    longitude: 76.9558,
    timezone: "Asia/Kolkata",
    regional_note:
      "Coimbatore, the Manchester of South India. Marudamalai Murugan Temple and Perur Pateeswarar Temple are the city's major sacred sites. Pongal, Tamil New Year, and Karthigai Deepam are the major festivals. Coimbatore's textile and engineering industries actively consult Panchanga for factory inaugurations, machine start-ups, and new business ventures.",
    local_festivals: ["Pongal", "Tamil New Year", "Karthigai Deepam"],
  },
  {
    slug: "jabalpur",
    name: "Jabalpur",
    name_hi: "जबलपुर",
    state: "Madhya Pradesh",
    latitude: 23.1815,
    longitude: 79.9864,
    timezone: "Asia/Kolkata",
    regional_note:
      "Jabalpur, on the banks of the Narmada River. Narmada River is one of India's most sacred rivers; the Narmada Parikrama (circumambulation) is a major spiritual undertaking. Chausath Yogini Temple (ancient Tantric temple), Pisanhari ki Madhiya Jain temple, and Tilwara Ghat are major sacred sites. Navratri and Diwali are celebrated with strong community devotion.",
    local_festivals: ["Navratri", "Narmada Jayanti", "Diwali"],
  },
  {
    slug: "gwalior",
    name: "Gwalior",
    name_hi: "ग्वालियर",
    state: "Madhya Pradesh",
    latitude: 26.2183,
    longitude: 78.1828,
    timezone: "Asia/Kolkata",
    regional_note:
      "Gwalior. Achaleshwar Mahadev Temple (inside the fort) and Scindia Kanya Vidyalaya Durga Mandir are major pilgrimage sites. Ram Navami and Navratri are Gwalior's major festivals. The city's royal Scindia family tradition kept classical Jyotish and muhurta practice alive through royal patronage, and this tradition continues in Gwalior's cultural life.",
    local_festivals: ["Ram Navami", "Navratri", "Dussehra"],
  },
  {
    slug: "vijayawada",
    name: "Vijayawada",
    name_hi: "विजयवाड़ा",
    state: "Andhra Pradesh",
    latitude: 16.5062,
    longitude: 80.648,
    timezone: "Asia/Kolkata",
    regional_note:
      "Vijayawada, Andhra Pradesh's commercial capital on the Krishna River. Kanaka Durga Temple (one of the most powerful Shakti peethas in South India) is the city's most revered pilgrimage site. Ugadi, Dasara, and Sankranti are major festivals. The Kanaka Durga temple's rituals are deeply tied to the Panchanga — special austerities and timings during Navratri attract millions of devotees annually.",
    local_festivals: ["Ugadi", "Navratri (Dasara)", "Sankranti"],
  },
  {
    slug: "jodhpur",
    name: "Jodhpur",
    name_hi: "जोधपुर",
    state: "Rajasthan",
    latitude: 26.2389,
    longitude: 73.0243,
    timezone: "Asia/Kolkata",
    regional_note:
      "Jodhpur, the Blue City. Mehrangarh Fort temple (Chamunda Mata), Masuria Hill Garden Temple, and Kailana Lake temples are major sacred sites. Navratri, Teej, and Marwar Festival are key events. Jodhpur's Marwari trading community, one of India's most commercially astute, has centuries-old traditions of consulting muhurta for business, property, and wedding decisions.",
    local_festivals: ["Navratri", "Teej", "Marwar Festival"],
  },
  {
    slug: "madurai",
    name: "Madurai",
    name_hi: "मदुरई",
    state: "Tamil Nadu",
    latitude: 9.9252,
    longitude: 78.1198,
    timezone: "Asia/Kolkata",
    regional_note:
      "Madurai, one of the oldest continuously inhabited cities in the world. Meenakshi Amman Temple — one of India's grandest Dravidian temples — defines the city spiritually. Chithirai Festival (Meenakshi Thirukalyanam) is the world's largest temple festival, attracting over a million devotees. Tamil Panchanga traditions in Madurai date back over 2,000 years.",
    local_festivals: ["Chithirai Festival", "Pongal", "Karthigai Deepam"],
  },
  {
    slug: "raipur",
    name: "Raipur",
    name_hi: "रायपुर",
    state: "Chhattisgarh",
    latitude: 21.2514,
    longitude: 81.6296,
    timezone: "Asia/Kolkata",
    regional_note:
      "Raipur, Chhattisgarh's capital. Dudhadhari Mandir and Mahamaya Temple (Bilaspur) are major pilgrimage sites. Navratri (especially Dantewada Navratri), Pola (bull worship festival), and Hareli (harvest festival) are Chhattisgarh's distinctive celebrations. Raipur's growing industrial and commercial sector actively consults muhurta for factory inaugurations and major business decisions.",
    local_festivals: ["Navratri", "Pola", "Hareli"],
  },
  {
    slug: "kochi",
    name: "Kochi",
    name_hi: "कोच्चि",
    state: "Kerala",
    latitude: 9.9312,
    longitude: 76.2673,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kochi (Cochin), Kerala's commercial capital. Ernakulam Shiva Temple, Thrikkakkara Vamana Temple, and Hill Palace are major sacred sites. Onam (Kerala's harvest festival honoring King Mahabali) and Vishu (Malayalam New Year) are the defining festivals. Kerala has a unique astrological tradition — the observation-based drik-ganita reckoning is used alongside traditional almanacs, and muhurta consultation before Onam sadhya and Vishu is common.",
    local_festivals: ["Onam", "Vishu", "Thrissur Pooram"],
  },
  {
    slug: "chandigarh",
    name: "Chandigarh",
    name_hi: "चंडीगढ़",
    state: "Punjab/Haryana",
    latitude: 30.7333,
    longitude: 76.7794,
    timezone: "Asia/Kolkata",
    regional_note:
      "Chandigarh, the planned capital of Punjab and Haryana. Mansa Devi Temple and Panchkula Nada Sahib Gurudwara are the city's major pilgrimage destinations. Baisakhi, Lohri, and Gurpurab are the most celebrated festivals. Chandigarh's educated, progressive population continues traditional Panchanga practices for marriages, career moves, and business decisions — demonstrating that modernity and tradition coexist.",
    local_festivals: ["Baisakhi", "Lohri", "Diwali"],
  },
  {
    slug: "mysore",
    name: "Mysore",
    name_hi: "मैसूर",
    state: "Karnataka",
    latitude: 12.2958,
    longitude: 76.6394,
    timezone: "Asia/Kolkata",
    regional_note:
      "Mysore (Mysuru), Karnataka's cultural capital. The Chamundeshwari Temple atop Chamundi Hill is one of South India's most powerful Shakti shrines. Mysore Dasara is the world-famous royal festival — the Royal Mysore Palace illuminated with 100,000 lights is iconic. Karnataka's Vedic tradition, including Varahamihira's legacy, makes this region central to Indian astrological heritage.",
    local_festivals: ["Mysore Dasara", "Ugadi", "Makara Sankranti"],
  },
  {
    slug: "allahabad",
    name: "Prayagraj",
    name_hi: "प्रयागराज",
    state: "Uttar Pradesh",
    latitude: 25.4358,
    longitude: 81.8463,
    timezone: "Asia/Kolkata",
    regional_note:
      "Prayagraj (Allahabad), at the Triveni Sangam of Ganga, Yamuna, and the mythical Saraswati, is one of India's holiest cities. Bade Hanuman Temple, Alopi Devi Temple, and Shringverpur are major sites. Kumbh Mela (world's largest human gathering) happens here every 12 years, with Ardh Kumbh every 6 years. Panchanga timing governs every ritual bath (Shahi Snan) during Kumbh.",
    local_festivals: ["Kumbh Mela", "Makar Sankranti Mela", "Ram Navami"],
  },
  {
    slug: "thiruvananthapuram",
    name: "Thiruvananthapuram",
    name_hi: "तिरुवनंतपुरम",
    state: "Kerala",
    latitude: 8.5241,
    longitude: 76.9366,
    timezone: "Asia/Kolkata",
    regional_note:
      "Thiruvananthapuram (Trivandrum), Kerala's capital. Padmanabhaswamy Temple — holding the world's largest known temple treasury — is one of India's most sacred Vishnu temples. The Swathi Tirunal Music Festival honors Kerala's royal patron of classical arts. Onam and Vishu are the defining festivals. The city's strong Kerala Jyotish tradition (including Thacholi school of astrology) makes it a center of classical Vedic learning.",
    local_festivals: ["Onam", "Vishu", "Attukal Pongala"],
  },
  {
    slug: "haridwar",
    name: "Haridwar",
    name_hi: "हरिद्वार",
    state: "Uttarakhand",
    latitude: 29.9457,
    longitude: 78.1642,
    timezone: "Asia/Kolkata",
    regional_note:
      "Haridwar, the Gateway to the Gods, is one of India's seven most sacred cities (Sapta Puri). Mansa Devi Temple, Chandi Devi Temple, and Maya Devi Temple are Haridwar's Shakti shrines. Kumbh Mela in Haridwar (every 12 years) and Kanwar Yatra (Shiva devotee pilgrimage) draw tens of millions. The Ganga Aarti at Har Ki Pauri is one of India's most moving daily spiritual rituals.",
    local_festivals: ["Kumbh Mela", "Kanwar Yatra", "Ganga Dussehra"],
  },
  {
    slug: "rishikesh",
    name: "Rishikesh",
    name_hi: "ऋषिकेश",
    state: "Uttarakhand",
    latitude: 30.0869,
    longitude: 78.2676,
    timezone: "Asia/Kolkata",
    regional_note:
      "Rishikesh, the Yoga Capital of the World. Triveni Ghat morning aarti, Neelkanth Mahadev Temple, and Ram Jhula temples are the major sacred sites. International Yoga Festival (March) draws practitioners from 100+ countries. Rahu Kaal and choghadiya are particularly important for sadhana timing — spiritual practitioners here integrate astronomical knowledge deeply into practice.",
    local_festivals: ["International Yoga Festival", "Mahashivaratri", "Kanwar Yatra"],
  },
  {
    slug: "dehradun",
    name: "Dehradun",
    name_hi: "देहरादून",
    state: "Uttarakhand",
    latitude: 30.3165,
    longitude: 78.0322,
    timezone: "Asia/Kolkata",
    regional_note:
      "Dehradun, the capital of Uttarakhand in the Doon Valley. Tapkeshwar Temple, Shri Ram Rai Darbar, and Sai Darbar Mandir are major sacred sites. Mahashivaratri and Navratri are the major festivals. As home to India's premier defense and research institutions, Dehradun has a unique blend of modern and traditional — muhurta consultation before major career and academic decisions is common.",
    local_festivals: ["Mahashivaratri", "Navratri", "Diwali"],
  },
  {
    slug: "shimla",
    name: "Shimla",
    name_hi: "शिमला",
    state: "Himachal Pradesh",
    latitude: 31.1048,
    longitude: 77.1734,
    timezone: "Asia/Kolkata",
    regional_note:
      "Shimla, Himachal Pradesh's capital and former British summer capital. Jakhu Temple (dedicated to Lord Hanuman, 2455m above sea level) and Tara Devi Temple are the city's sacred landmarks. Shimla's apple orchards and tourism economy are tied to seasonal festivals like Dussehra and Lohri. High altitude means longer twilights — panchanga calculations are especially valuable here.",
    local_festivals: ["Dussehra (Kullu Dussehra)", "Lohri", "Navratri"],
  },
  {
    slug: "bhubaneswar",
    name: "Bhubaneswar",
    name_hi: "भुवनेश्वर",
    state: "Odisha",
    latitude: 20.2961,
    longitude: 85.8245,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bhubaneswar, the Temple City of India. The city has over 700 temples — Lingaraj Temple, Mukteshwar Temple, and Rajarani Temple are among India's finest examples of Kalinga architecture. Rath Yatra (Puri Jagannath) and Raja Parba (Odisha's women's festival) are major observances. Odia Panchanga (Odia almanac) has a centuries-old tradition, with Rath Yatra dates determined by precise astronomical calculations.",
    local_festivals: ["Rath Yatra", "Raja Parba", "Nuakhai"],
  },
  {
    slug: "guwahati",
    name: "Guwahati",
    name_hi: "गुवाहाटी",
    state: "Assam",
    latitude: 26.1445,
    longitude: 91.7362,
    timezone: "Asia/Kolkata",
    regional_note:
      "Guwahati, the Gateway to Northeast India. Kamakhya Temple, one of the most powerful Shakti peethas (on Nilachal Hill), is one of India's most visited pilgrimage sites. Ambubachi Mela (when Goddess Kamakhya menstruates — a 3-day festival) is unique to Guwahati. Bihu festivals (Rongali, Kongali, Bhogali) mark Assam's calendar.",
    local_festivals: ["Ambubachi Mela", "Rongali Bihu", "Durga Puja"],
  },
  {
    slug: "mangaluru",
    name: "Mangaluru",
    name_hi: "मंगलुरु",
    state: "Karnataka",
    latitude: 12.9141,
    longitude: 74.856,
    timezone: "Asia/Kolkata",
    regional_note:
      "Mangaluru (Mangalore), Karnataka's coastal city. Kudroli Shri Gokarnanatheshwara Temple and Kateel Durgaparameshwari Temple are the region's premier sacred sites. Yakshagana (traditional dance-drama), Navroz (Parsi New Year celebrated by the local Goud Saraswat community), and Dasara are major events. Mangaluru's Tulu Brahmin community has preserved classical Vedic astrological traditions for centuries.",
    local_festivals: ["Dasara", "Navratri", "Bidar Udyambhara"],
  },
  {
    slug: "tirupati",
    name: "Tirupati",
    name_hi: "तिरुपति",
    state: "Andhra Pradesh",
    latitude: 13.6288,
    longitude: 79.4192,
    timezone: "Asia/Kolkata",
    regional_note:
      "Tirupati, home to the Tirumala Venkateswara Temple (world's most visited religious site with 50,000–100,000 daily visitors). The temple's Brahmotsavam (9-day annual festival) is one of India's grandest religious celebrations. Every ritual in the Tirumala temple is governed by the Panchanga — muhurta is not optional here, it is sacred law. Pilgrims consult choghadiya for their darshan timings.",
    local_festivals: ["Brahmotsavam", "Vaikunta Ekadasi", "Rathasapthami"],
  },
  {
    slug: "ujjain",
    name: "Ujjain",
    name_hi: "उज्जैन",
    state: "Madhya Pradesh",
    latitude: 23.1765,
    longitude: 75.7885,
    timezone: "Asia/Kolkata",
    regional_note:
      "Ujjain (ancient Avantika), one of India's seven sacred cities, is the meridian city of Vedic astronomy — all Vedic astrology calculations historically used Ujjain as the prime meridian (Lanka Rekha). Mahakaleshwar Jyotirlinga (Shiva's self-manifested form) is the city's supreme sacred site. Kumbh Mela (Simhastha) happens here every 12 years. The city's unique astronomical heritage means Panchanga calculation in Ujjain has special historical and spiritual authority.",
    local_festivals: ["Kumbh Mela (Simhastha)", "Navratri", "Mahashivaratri"],
  },
  {
    slug: "pushkar",
    name: "Pushkar",
    name_hi: "पुष्कर",
    state: "Rajasthan",
    latitude: 26.4898,
    longitude: 74.5511,
    timezone: "Asia/Kolkata",
    regional_note:
      "Pushkar, Rajasthan's sacred lake city. The Brahma Temple (one of India's only Brahma temples) and Savitri Temple are unique sacred sites. Pushkar Mela (the world's largest camel fair) coincides with Kartik Purnima — one of Hinduism's most auspicious full moons. Pushkar is a pilgrimage center where timing (muhurta) is paramount — every ritual bath in Pushkar Lake is performed in accordance with Panchanga.",
    local_festivals: ["Pushkar Mela", "Kartik Purnima", "Navratri"],
  },
  {
    slug: "vrindavan",
    name: "Vrindavan",
    name_hi: "वृंदावन",
    state: "Uttar Pradesh",
    latitude: 27.5706,
    longitude: 77.6727,
    timezone: "Asia/Kolkata",
    regional_note:
      "Vrindavan, the eternal playground of Lord Krishna. Banke Bihari Temple, ISKCON Temple, Prem Mandir, and hundreds of other Krishna temples make Vrindavan one of the most temple-dense sacred cities. Holi in Vrindavan (Phoolon wali Holi, Lathmar Holi in nearby Barsana) is the world's most vibrant color festival. Every festival in Vrindavan follows precise Panchanga timing — especially Janmashtami (Lord Krishna's birth).",
    local_festivals: ["Janmashtami", "Holi (Phoolon wali Holi)", "Radhashtami"],
  },
  {
    slug: "ayodhya",
    name: "Ayodhya",
    name_hi: "अयोध्या",
    state: "Uttar Pradesh",
    latitude: 26.7922,
    longitude: 82.1998,
    timezone: "Asia/Kolkata",
    regional_note:
      "Ayodhya, birthplace of Lord Rama and one of India's seven sacred cities (Sapta Puri). Ram Lalla Temple (newly inaugurated in 2024), Hanuman Garhi, and Kanak Bhavan are the city's sacred centers. Ram Navami (Lord Rama's birthday) and Diwali (Rama's return to Ayodhya) are Ayodhya's most sacred celebrations. Every puja and ceremony is governed by precise Panchanga timing.",
    local_festivals: ["Ram Navami", "Diwali", "Parikrama Mela"],
  },
];
